import { z } from "zod";
import { IdentifiedOrDeletedAuthor } from "./author";
import { Document, FileBase, FileEntry, PrivateFile, PublicFile } from "./file-base";
import { IsoDateString } from "./isoDate";

// Re-export file schemas (defined in file-base.ts to break circular deps)
export { FileBase, FileEntry, PublicFile, PrivateFile, Document };

export const FileListEntry = FileEntry.and(
    z.object({
        references: z.number().nullable(),
        author: IdentifiedOrDeletedAuthor,
        organizations: z.array(z.string()).nullable(),
        discussionIds: z.array(
            z.object({
                id: z.number(),
                title: z.string(),
                date: IsoDateString.nullish(),
            }),
        ),
    }),
);

/** @deprecated Use FileListEntry instead */
export const DocumentListEntry = z.object({
    id: z.string(),
    uploaded: IsoDateString,
    name: z.string().nullish(),
    displayName: z.string().nullish(),
    description: z.string().nullish(),
    sizeBytes: z.number().nullish(),
    references: z.number().nullable(),
    author: IdentifiedOrDeletedAuthor,
    organizations: z.array(z.string()).nullable(),
    type: z.string().nullish(),
    context: z.enum(["PUBLIC_ATTACHMENT", "PRIVATE_ATTACHMENT"]).nullish(),
    aiDescriptionShort: z.string().nullish(),
    aiDescriptionLong: z.string().nullish(),
    aiDescriptionStatus: z.enum(["PENDING", "DONE", "ERROR"]).nullish(),
    aiOptOut: z.boolean().nullish(),
    userCanEdit: z.boolean(),
    discussionIds: z.array(
        z.object({
            id: z.number(),
            title: z.string(),
            date: IsoDateString.nullish(),
        }),
    ),
});
